import { SignatureOutlined } from "@ant-design/icons"
import { Button, Tooltip } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { useSendForSignature } from "../hooks/use-send-for-signature.ts"
import type { SubjectType } from "../types/esign.types.ts"

interface SendForSignatureButtonProps {
  leadId: string | null | undefined
  subjectType?: SubjectType
  subjectId?: string
  iconOnly?: boolean
}

export function SendForSignatureButton({
  leadId,
  subjectType,
  subjectId,
  iconOnly = false
}: SendForSignatureButtonProps) {
  const { t } = useTranslation()
  const sendForSignature = useSendForSignature(leadId)
  if (!sendForSignature) return null

  const label = t("esign.entry.sendForSignature")
  const open = (event: React.MouseEvent) => {
    event.stopPropagation()
    sendForSignature(
      subjectType && subjectId
        ? { type: subjectType, id: subjectId }
        : undefined
    )
  }

  if (iconOnly) {
    return (
      <Tooltip title={label}>
        <Button
          icon={<SignatureOutlined />}
          aria-label={label}
          onClick={open}
        />
      </Tooltip>
    )
  }

  return (
    <Button icon={<SignatureOutlined />} onClick={open}>
      {label}
    </Button>
  )
}
